import Model from "./Model";

export const SituacaoSubEtapaType = {
  ATIVA: 1,
  DESATIVADA: 0,
};

export default class SubEtapa extends Model {
  constructor(franquia) {
    super();
    Object.assign(this, franquia);
  }

  get ativa() {
    return this.situacao === SituacaoSubEtapaType.ATIVA;
  }

  get desativada() {
    return this.situacao === SituacaoSubEtapaType.DESATIVADA;
  }
}
